import { render } from "./SurveyPage.vue?vue&type=template&id=8390cc84&ts=true"
import script from "./SurveyPage.vue?vue&type=script&lang=ts"
export * from "./SurveyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Surveys/SurveyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8390cc84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8390cc84', __exports__)) {
    api.reload('8390cc84', __exports__)
  }
  
  module.hot.accept("./SurveyPage.vue?vue&type=template&id=8390cc84&ts=true", () => {
    api.rerender('8390cc84', render)
  })

}


export default __exports__